import { React } from "react";
import { CRow, CCol, CCard, CCardBody } from "@coreui/react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import TeacherAdmin from "../../components/Teacher/TeacherAdmin";
import PacmanLoader from "../../components/Pacmanloader/Pacmanloader";
import {
  GetTeacherInfoById,
  GetTeacherInformation,
} from "../../actions/teacherQueries";

export default function TeacherTeacher(props) {
  const teacherData = GetTeacherInfoById(props.match.params.teacherId);
  const teacherInfo = GetTeacherInformation();

  if (teacherData.isLoading) {
    return <PacmanLoader color={"#20a8d8"} size={15} loading={true} />;
  }
  return (
    <div className="animated fadeIn">
      <CRow>
        <CCol lg={12}>
          <CCard>
            <Nav tabs className="bg-primary">
              <NavItem>
                <NavLink className="active text-primary">
                  <FontAwesomeIcon icon="map" />
                  &nbsp; <FormattedMessage id="Admin" />
                </NavLink>
              </NavItem>
            </Nav>
            <CCardBody className="responsive-card animated fadeIn">
              <TeacherAdmin
                teacherData={teacherData}
                teacherInfo={teacherInfo}
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  );
}
